import React, { useEffect, useState } from "react";
import "./BlockedUser.css";
import { getBlockedUsers } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import AddNewBlockUser from "./AddBlockUser"

const BlockedUserPage = () => {
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const token = useSelector((state) => state.userReducer.token);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const fetchBlockedUsers = async (currentPage,searchTerm) => {
    try {
      setLoading(true);
      const response = await getBlockedUsers(currentPage, searchTerm);
      setBlockedUsers(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch blocked users.");
    }
  };

useEffect(() => {
  if (searchTerm !== "") {
    const delayDebounce = setTimeout(() => {
      fetchBlockedUsers(1, searchTerm);
    }, 2000);

    return () => clearTimeout(delayDebounce);
  }
}, [searchTerm]);

useEffect(() => {
  if (searchTerm === "") {
    fetchBlockedUsers(currentPage, "");
  }
}, [currentPage,searchTerm]);

  return (
    <div className="blocked-status-table-container">
        <div className="block-key-add">
      <div className="blocked-status-heading">
        <h2 className="blocked-status-table-title">Blocked User</h2>
        <input
          className="blocked-input-field-container"
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
        <div>
          <button className="keyword-add-button" onClick={() => setIsAddModalOpen(true)}>
            Add +
          </button>
        </div>
        </div>
      <table className="blocked-table">
        <thead>
          <tr>
            <th>Payer name</th>
            <th>Payer email</th>
            <th>Payer phone number</th>
            <th>Request VPA</th>
            <th>Response VPA</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="6">Loading...</td>
            </tr>
          ) : blockedUsers?.length > 0 ? (
            blockedUsers.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item?.name ?? '-'}</td>
                  <td>{item?.email ?? '-'}</td>
                  <td>{item?.phoneNumber ?? '-'}</td>
                  <td
                    className="cursor-pointer"
                    data-tooltip-id="tooltip-order"
                    data-tooltip-content={item?.vpa}
                    onClick={() => {
                      navigator.clipboard.writeText(item?.vpa);
                      toast.success("Request VPA copied successfully.");
                    }}
                  >
                    {item.vpa ? item.vpa?.slice(0, 10) + "..." : "-"}
                  </td>
                  <td
                    className="cursor-pointer"
                    data-tooltip-id="tooltip-transaction"
                    data-tooltip-content={item?.responseVpa}
                    onClick={() => {
                      navigator.clipboard.writeText(item?.responseVpa);
                      toast.success("Response VPA copied successfully.");
                    }}
                  >
                    {item?.responseVpa
                      ? item?.responseVpa?.slice(0, 10) + "..."
                      : "-"}
                  </td>
                  <td>
                    {new Date(item?.updatedAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6">No data found.</td>
            </tr>
          )}
        </tbody>
      </table>
      <Tooltip id="tooltip-order" place="top" />
      <Tooltip id="tooltip-transaction" place="top" />
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
       {isAddModalOpen && <AddNewBlockUser onClose={() => setIsAddModalOpen(false)} />}
    </div>
  );
};

export default BlockedUserPage;
